<template>
  <el-dialog
    :model-value="visible"
    @close="$emit('close')"
    width="400px"
    :close-on-click-modal="false"
    append-to-body
    dialog-class="custom-dialog-radius"
    :title="settingName"
  >
    <div class="interview-settings">


      <!-- 标签切换 -->
      <!-- <div class="tab-container">
        <el-button v-if="currentTab === 'basic'" class="primary-btn" :class="{ active: currentTab === 'basic' }" @click="currentTab = 'basic'">基础设置</el-button>
        <el-button v-if="currentTab === 'shortcut'" class="primary-btn" :class="{ active: currentTab === 'basic' }" @click="currentTab = 'basic'">基础设置</el-button>"
      </div> -->

      <!-- 基础设置内容 -->
      <div v-if="currentTab === 'basic'">
        <el-form ref="formRef" :rules="rules" :model="formData" label-width="120px" style="margin-top: 0px;" label-position="top">
          <el-form-item label="面试名称" prop="interviewName">
              <el-input
                v-model="formData.interviewName"
                disabled
                placeholder="请输入您面试的面试名称，不超过20个字"
              ></el-input>
            </el-form-item>
            <el-form-item label="面试岗位" prop="positionInfo">
              <el-select v-model="formData.positionInfo" placeholder="请选择面试岗位">
                <el-option-group label="技术">
                  <el-option label="前端开发" value="frontend"></el-option>
                  <el-option label="后端开发" value="backend"></el-option>
                  <el-option label="全栈开发" value="fullstack"></el-option>
                  <el-option label="Android开发" value="android"></el-option>
                  <el-option label="iOS开发" value="ios"></el-option>
                  <el-option label="算法工程师" value="algorithm"></el-option>
                  <el-option label="人工智能" value="ai"></el-option>
                  <el-option label="数据工程师" value="data"></el-option>
                  <el-option label="测试工程师" value="test"></el-option>
                  <el-option label="运维工程师" value="devops"></el-option>
                  <el-option label="安全工程师" value="security"></el-option>
                  <el-option label="架构师" value="architecture"></el-option>
                  <el-option label="数据库管理员" value="dba"></el-option>
                  <el-option label="嵌入式开发" value="embedded"></el-option>
                  <el-option label="游戏开发" value="game"></el-option>
                </el-option-group>
                <el-option-group label="产品">
                  <el-option label="产品经理" value="product_manager"></el-option>
                  <el-option label="产品设计师" value="product_design"></el-option>
                  <el-option label="UI设计师" value="ui_design"></el-option>
                  <el-option label="UX设计师" value="ux_design"></el-option>
                  <el-option label="交互设计师" value="interaction_design"></el-option>
                  <el-option label="视觉设计师" value="visual_design"></el-option>
                  <el-option label="游戏策划" value="game_design"></el-option>
                </el-option-group>
                <el-option-group label="运营">
                  <el-option label="运营专员" value="operations"></el-option>
                  <el-option label="市场营销" value="marketing"></el-option>
                  <el-option label="内容运营" value="content"></el-option>
                  <el-option label="社区运营" value="community"></el-option>
                  <el-option label="新媒体运营" value="media"></el-option>
                  <el-option label="电商运营" value="ecommerce"></el-option>
                  <el-option label="产品运营" value="product_operations"></el-option>
                  <el-option label="用户运营" value="user_operations"></el-option>
                  <el-option label="活动运营" value="activity_operations"></el-option>
                  <el-option label="SEO" value="seo"></el-option>
                </el-option-group>
                <el-option-group label="销售">
                  <el-option label="销售代表" value="sales"></el-option>
                  <el-option label="销售经理" value="sales_manager"></el-option>
                  <el-option label="大客户销售" value="key_account"></el-option>
                  <el-option label="售前顾问" value="pre_sales"></el-option>
                  <el-option label="渠道销售" value="channel"></el-option>
                  <el-option label="商务拓展" value="bd"></el-option>
                  <el-option label="客户成功" value="customer_success"></el-option>
                </el-option-group>
                <el-option-group label="职能">
                  <el-option label="人力资源" value="hr"></el-option>
                  <el-option label="招聘专员" value="recruiter"></el-option>
                  <el-option label="人事经理" value="hrm"></el-option>
                  <el-option label="HRBP" value="hrbp"></el-option>
                  <el-option label="财务" value="finance"></el-option>
                  <el-option label="会计" value="accounting"></el-option>
                  <el-option label="法务" value="legal"></el-option>
                  <el-option label="行政" value="admin"></el-option>
                  <el-option label="助理" value="assistant"></el-option>
                </el-option-group>
                <el-option-group label="市场与公关">
                  <el-option label="品牌公关" value="brand"></el-option>
                  <el-option label="市场策划" value="marketing_planning"></el-option>
                  <el-option label="市场经理" value="marketing_manager"></el-option>
                  <el-option label="公关经理" value="pr"></el-option>
                  <el-option label="广告投放" value="advertising"></el-option>
                  <el-option label="媒介策划" value="media_planning"></el-option>
                </el-option-group>
                <el-option-group label="供应链">
                  <el-option label="采购" value="purchase"></el-option>
                  <el-option label="物流" value="logistics"></el-option>
                  <el-option label="仓储" value="inventory"></el-option>
                  <el-option label="贸易" value="trade"></el-option>
                  <el-option label="供应链" value="supply_chain"></el-option>
                </el-option-group>
                <el-option-group label="教育培训">
                  <el-option label="教师" value="teacher"></el-option>
                  <el-option label="培训师" value="trainer"></el-option>
                  <el-option label="教务管理" value="education_admin"></el-option>
                  <el-option label="职业规划师" value="career_counselor"></el-option>
                </el-option-group>
                <el-option-group label="咨询">
                  <el-option label="管理咨询" value="management_consulting"></el-option>
                  <el-option label="财务咨询" value="financial_consulting"></el-option>
                  <el-option label="IT咨询" value="it_consulting"></el-option>
                  <el-option label="人力资源咨询" value="hr_consulting"></el-option>
                </el-option-group>
              </el-select>
            </el-form-item>
            <el-form-item label="代码类型" prop="programmingLanguage">
              <el-select v-model="formData.programmingLanguage" placeholder="请选择使用的代码类型">
                <el-option label="非编程面试" value="none"></el-option>
                <el-option-group label="前端">
                  <el-option label="JavaScript" value="javascript"></el-option>
                  <el-option label="TypeScript" value="typescript"></el-option>
                  <el-option label="HTML" value="html"></el-option>
                  <el-option label="CSS" value="css"></el-option>
                  <el-option label="React" value="react"></el-option>
                  <el-option label="Vue" value="vue"></el-option>
                </el-option-group>
                <el-option-group label="后端">
                  <el-option label="Java" value="java"></el-option>
                  <el-option label="Python" value="python"></el-option>
                  <el-option label="Go" value="golang"></el-option>
                  <el-option label="Node.js" value="nodejs"></el-option>
                  <el-option label="PHP" value="php"></el-option>
                  <el-option label="C#" value="csharp"></el-option>
                  <el-option label="C++" value="cpp"></el-option>
                </el-option-group>
                <el-option-group label="移动端">
                  <el-option label="Swift" value="swift"></el-option>
                  <el-option label="Kotlin" value="kotlin"></el-option>
                  <el-option label="Objective-C" value="objectivec"></el-option>
                  <el-option label="Flutter" value="flutter"></el-option>
                </el-option-group>
                <el-option-group label="其他">
                  <el-option label="SQL" value="sql"></el-option>
                  <el-option label="Shell" value="shell"></el-option>
                  <el-option label="Rust" value="rust"></el-option>
                </el-option-group>
              </el-select>
            </el-form-item>
            <el-form-item label="简历" prop="resumeText">
              <el-input
                type="textarea"
                v-model="formData.resumeText"
                placeholder="将您的简历文本信息粘贴至此，大模型会回答更准确"
              ></el-input>

            </el-form-item>
            <el-form-item label="岗位信息" prop="jobRequirements">
              <el-input
                type="textarea"
                v-model="formData.jobRequirements"
                placeholder="将您要面试的岗位信息粘贴至此，大模型会回答更准确"
              ></el-input>
            </el-form-item>

        </el-form>
      </div>

      <!-- 快捷键设置内容 -->
      <div v-if="currentTab === 'shortcut'">
        <el-form ref="shortcutFormRef" :model="shortcutFormData" label-width="120px" style="margin-top: 0px;" label-position="top">
        
         
          <el-form-item label="快答">
            <div class="shortcut-container">
              <div class="shortcut-row">
                <span class="os-label">Mac:</span>
                <el-input value="option+P" disabled class="shortcut-input"></el-input>
              </div>
              <div class="shortcut-row">
                <span class="os-label">Windows:</span>
                <el-input value="Alt+P" disabled class="shortcut-input"></el-input>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="深度回答">
            <div class="shortcut-container">
              <div class="shortcut-row">
                <span class="os-label">Mac:</span>
                <el-input value="option+O" disabled class="shortcut-input"></el-input>
              </div>
              <div class="shortcut-row">
                <span class="os-label">Windows:</span>
                <el-input value="Alt+O" disabled class="shortcut-input"></el-input>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="截图">
            <div class="shortcut-container">
              <div class="shortcut-row">
                <span class="os-label">Mac:</span>
                <el-input value="option+I" disabled class="shortcut-input"></el-input>
              </div>
              <div class="shortcut-row">
                <span class="os-label">Windows:</span>
                <el-input value="Alt+I" disabled class="shortcut-input"></el-input>
              </div>
            </div>
          </el-form-item>
          <!-- <el-form-item label="是否启用语音触发快答">
            <el-switch v-model="form.voiceTrigger"  style="width: 100%;"></el-switch>
          </el-form-item>
          <el-form-item label="触发关键词">
            <el-input v-model="form.voiceTriggerWords" style="width: 100%;"></el-input>
          </el-form-item> -->
        </el-form>
      </div>

      <!-- 按钮 -->
      <!-- <div class="button-group">
        <el-button class="primary-btn" @click="cancel">取消</el-button>
        <el-button class="primary-btn" type="primary" @click="save">保存</el-button>
      </div> -->
    </div>
  </el-dialog>
</template>
<script>
import {getUserInfo,updateUser} from "@/api/login/login";
import { interviewInfo,interviewUpdate } from "@/api/interview";
import { isMacOS, getShortcutText } from "@/utils/common";
export default {
  
  data() {
    return {
      captureShortcut: getShortcutText('I'),
      fastAnswerShortcut: getShortcutText('P'),
      deepAnswerShortcut: getShortcutText('O'),
      // currentTab: 'basic', // 默认选中快捷键设置
      formData: {
        companyName: '', // 公司名称
        position: '', // 面试岗位
        model: '', // 大模型
        codeType: '', // 代码类型
        resume: null, // 简历文件
        positionInfo: '', // 简历内容
      },
      userInfo: {
        phone: '150******00',
        email: 'ABCabc',
        inviteCode: 'ABCabc',
      },
      form: {
        voiceTrigger: false, // 是否开启语音触发
        voiceTriggerWords: '',  //语音触发词列表(逗号隔开)
        shortcutConfig: ''
      },
      shortcutFormData: {
        screenshotShortcut: getShortcutText('I'), // 截图快捷键
        quickAnswerShortcut: getShortcutText('P'), // 快答快捷键
        enableVoiceTrigger: true, // 是否启用语音触发快答
        triggerKeyword: '我想一下,给我一分钟可以吗', // 触发关键词
      },
      jobOptions: [
        {
          value: "软件开发与技术",
          label: "软件开发与技术",
          children: [
            {
              value: "Web开发",
              label: "Web开发",
              children: [
                { value: "前端工程师", label: "前端工程师" },
                { value: "后端工程师", label: "后端工程师" },
                { value: "全栈工程师", label: "全栈工程师" }
              ]
            },
            {
              value: "移动端开发",
              label: "移动端开发",
              children: [
                { value: "iOS开发工程师", label: "iOS开发工程师" },
                { value: "Android开发工程师", label: "Android开发工程师" },
                { value: "跨平台开发工程师", label: "跨平台开发工程师" }
              ]
            },
            {
              value: "游戏开发",
              label: "游戏开发",
              children: [
                { value: "游戏客户端工程师", label: "游戏客户端工程师" },
                { value: "游戏服务器工程师", label: "游戏服务器工程师" },
                { value: "游戏引擎开发工程师", label: "游戏引擎开发工程师" }
              ]
            },
            {
              value: "测试与质量保障",
              label: "测试与质量保障",
              children: [
                { value: "测试工程师", label: "测试工程师" },
                { value: "性能测试工程师", label: "性能测试工程师" },
                { value: "安全测试工程师", label: "安全测试工程师" }
              ]
            },
            {
              value: "数据与算法",
              label: "数据与算法",
              children: [
                { value: "算法工程师", label: "算法工程师" },
                { value: "数据工程师", label: "数据工程师" },
                { value: "数据分析师", label: "数据分析师" }
              ]
            },
            {
              value: "系统与运维",
              label: "系统与运维",
              children: [
                { value: "运维工程师", label: "运维工程师" },
                { value: "云计算工程师", label: "云计算工程师" },
                { value: "网络安全工程师", label: "网络安全工程师" }
              ]
            },
            {
              value: "嵌入式与底层开发",
              label: "嵌入式与底层开发",
              children: [
                { value: "嵌入式开发工程师", label: "嵌入式开发工程师" },
                { value: "固件工程师", label: "固件工程师" },
                { value: "逆向工程师", label: "逆向工程师" }
              ]
            }
          ]
        },
        // 以下为其他大类结构（示例）
        {
          value: "通信/硬件/半导体",
          label: "通信/硬件/半导体",
          children: [
            {
              value: "硬件设计",
              label: "硬件设计",
              children: [
                { value: "电路设计工程师", label: "电路设计工程师" },
                { value: "PCB设计工程师", label: "PCB设计工程师" },
                { value: "电源工程师", label: "电源工程师" }
              ]
            },
            {
              value: "芯片与集成电路",
              label: "芯片与集成电路",
              children: [
                { value: "IC设计工程师", label: "IC设计工程师" },
                { value: "IC验证工程师", label: "IC验证工程师" },
                { value: "DFT工程师", label: "DFT工程师" }
              ]
            }
          ]
        },
        // ...其他大类按相同格式补充
        {
          value: "机械/制造/能源",
          label: "机械/制造/能源",
          children: [
            {
              value: "机械设计",
              label: "机械设计",
              children: [
                { value: "机械结构工程师", label: "机械结构工程师" },
                { value: "传动系统工程师", label: "传动系统工程师" }
              ]
            },
            {
              value: "新能源与材料",
              label: "新能源与材料",
              children: [
                { value: "电池工程师", label: "电池工程师" },
                { value: "材料研发工程师", label: "材料研发工程师" }
              ]
            }
          ]
        },
        {
          value: "产品与用户研究",
          label: "产品与用户研究",
          children: [
            {
              value: "产品管理",
              label: "产品管理",
              children: [
                { value: "产品经理", label: "产品经理" },
                { value: "增长产品经理", label: "增长产品经理" }
              ]
            },
            {
              value: "策略与商业化",
              label: "策略与商业化",
              children: [
                { value: "策略产品经理", label: "策略产品经理" },
                { value: "商业化产品经理", label: "商业化产品经理" }
              ]
            }
          ]
        },
        {
          value: "商分/咨询/战略",
          label: "商分/咨询/战略",
          children: [
            {
              value: "商业分析",
              label: "商业分析",
              children: [
                { value: "商业分析师", label: "商业分析师" },
                { value: "市场洞察分析师", label: "市场洞察分析师" }
              ]
            },
            {
              value: "管理咨询",
              label: "管理咨询",
              children: [
                { value: "咨询顾问", label: "咨询顾问" },
                { value: "数字化转型顾问", label: "数字化转型顾问" }
              ]
            }
          ]
        },
        {
          value: "运营与增长",
          label: "运营与增长",
          children: [
            {
              value: "用户运营",
              label: "用户运营",
              children: [
                { value: "用户增长经理", label: "用户增长经理" },
                { value: "用户生命周期管理", label: "用户生命周期管理" }
              ]
            },
            {
              value: "内容运营",
              label: "内容运营",
              children: [
                { value: "内容策略经理", label: "内容策略经理" },
                { value: "短视频运营", label: "短视频运营" }
              ]
            }
          ]
        },
        {
          value: "市场与品牌",
          label: "市场与品牌",
          children: [
            {
              value: "数字营销",
              label: "数字营销",
              children: [
                { value: "SEO/SEM专员", label: "SEO/SEM专员" },
                { value: "社交媒体运营", label: "社交媒体运营" }
              ]
            },
            {
              value: "品牌与公关",
              label: "品牌与公关",
              children: [
                { value: "品牌经理", label: "品牌经理" },
                { value: "公关媒介专员", label: "公关媒介专员" }
              ]
            }
          ]
        },
        {
          value: "职能与支持",
          label: "职能与支持",
          children: [
            {
              value: "人力资源",
              label: "人力资源",
              children: [
                { value: "招聘专员", label: "招聘专员" },
                { value: "薪酬绩效专员", label: "薪酬绩效专员" }
              ]
            },
            {
              value: "财务与法务",
              label: "财务与法务",
              children: [
                { value: "财务会计", label: "财务会计" },
                { value: "法务合规专员", label: "法务合规专员" }
              ]
            }
          ]
        }
      ],
      rules: {
        
        positionInfo: [
          { required: true, message: "请选择面试岗位", trigger: "change" },
        ],
        model: [{ required: true, message: "请选择大模型", trigger: "change" }],
        programmingLanguage: [
          { message: "请选择代码类型", trigger: "change" },
        ],
        resumeText: [
          { max: 2000, message: "简历内容不超过2000个字", trigger: "blur" },
          { pattern: /^[a-zA-Z0-9\u4e00-\u9fa5\s]+$/, message: "请输入正确的简历内容", trigger: "blur" }
        ],
        jobRequirements: [
          { message: "请输入岗位信息", trigger: "blur" },
          { max: 500, message: "岗位信息不超过500个字", trigger: "blur" },
          { pattern: /^[a-zA-Z0-9\u4e00-\u9fa5\s]+$/, message: "请输入正确的岗位信息", trigger: "blur" }
        ],
      },
    };
  },
  computed: {
    isMac() {
      return isMacOS();
    }
  },
  props: {
    visible: Boolean, 
    currentTab: String,
    settingName: String,
    interviewId: {
    }
  },
   created() {
    this.getUserInfo();
    if(this.interviewId) {
      this.getInterviewInfo(this.interviewId);
    }
  },
  methods: {
    // 获取面试信息
    async getInterviewInfo(val) {
      const response = await interviewInfo(val);
      if (response.code === 200) {
        this.formData = response.data;
      }
    },
    // 获取用户信息
    async getUserInfo() {
       // 准备登录信息
      const obj = Object.assign({}, this.form);
      const response = await getUserInfo(obj)
      if (response.code === 200) {
         //  缓存当前登录用户信息
         this.userInfo = response.data;
         this.form = response.data.extraData;
        this.form.voiceTrigger = false
        }
    },
    // 处理简历上传
    handleResumeChange(file) {
      this.formData.resume = file.raw;
    },

    // 取消操作
    cancel() {
      this.$emit('close');
      
      // 清空表单或返回上一步
    },

    // 开始捕获快捷键
    startCaptureShortcut() {
      this.$refs.shortcutInput.focus();
      this.$message.info('请按下您想要设置的快捷键组合');
    },
    
    // 捕获快捷键
    // captureShortcut(event) {
    //   event.preventDefault();
      
    //   const keys = [];
      
    //   // 检查修饰键
    //   if (event.ctrlKey) keys.push('Ctrl');
    //   if (event.shiftKey) keys.push('Shift');
    //   if (event.altKey) keys.push('Alt');
    //   if (event.metaKey) keys.push('Meta');
      
    //   // 获取主键
    //   const key = event.key.toUpperCase();
    //   if (key !== 'CONTROL' && key !== 'SHIFT' && key !== 'ALT' && key !== 'META') {
    //     keys.push(key);
    //   }
      
    //   if (keys.length > 0) {
    //     this.form.shortcutConfig = keys.join('+');
    //     this.$message.success(`快捷键已设置为: ${this.form.shortcutConfig}`);
    //   }
    // },
    
    // 清除快捷键
    clearShortcut() {
      this.form.shortcutConfig = '';
      this.$message.success('快捷键已清除');
    },
    
    // 保存操作
    save() {
      if (this.currentTab === 'basic') {
        console.log('保存基础设置:', this.formData);
        const obj = Object.assign({}, this.formData);
        // positionInfo取自formData.positionInfos的最后一个元素的值
        // if (this.formData.positionInfo.length > 0) {
        //   obj.positionInfo = this.formData.positionInfo[this.formData.positionInfo.length - 1];
        // }
        interviewUpdate(this.interviewId,obj).then(response => {
          if (response.code === 200) {
            this.$message.success('设置保存成功');
            // this.getUserInfo(); // 更新用户信息
          } else {
            this.$message.error(response.message);
          }
        });
      } else if (this.currentTab === 'shortcut') {
        console.log('保存快捷键设置:', this.shortcutFormData);
        const obj = Object.assign({}, this.form);
        updateUser(obj).then(response => {
          if (response.code === 200) {
            this.$message.success('设置保存成功');
            this.getUserInfo(); // 更新用户信息
          } else {
            this.$message.error(response.message);
          }
        });
        // 提交快捷键设置逻辑
      }
    },
  },
};
</script>
<style scoped>
.interview-settings {
  max-width: 400px;
  margin: 0 auto;
  padding: 0px;
  border-radius: 16px;
}

.tab-container {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.el-form-item {
  margin-bottom: 12px;
}

.el-input,
.el-select {
  width: 100%;
}

.el-upload__tip {
  font-size: 12px;
  color: #999;
}

.button-group {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  margin-top: 20px;
}

.shortcut-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.shortcut-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.os-label {
  font-size: 14px;
  color: #606266;
  font-weight: 500;
  width: 70px;
  flex-shrink: 0;
  text-align: left;
}

.shortcut-input {
  width: 150px;
  flex-shrink: 0;
}

.shortcut-input-container {
  display: flex;
  align-items: center;
}

.shortcut-input:hover {
  border-color: #c0c4cc;
}

.shortcut-input:focus {
  border-color: #409eff;
  outline: none;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
}

.shortcut-input:empty::before {
  content: '点击设置快捷键';
  color: #c0c4cc;
}

:deep(.el-form-item__label) {
  font-weight: 600 !important;
  font-size: 14px !important;
  color: #1f2329 !important;
  display: block;
  margin-bottom: 8px;
}

/* 统一按钮风格 */
.primary-btn {
  width: 120px;
  height: 40px;
  border-radius: 8px;
  background: #409eff;
  color: #fff;
  font-size: 16px;
  border: none;
  margin-right: 10px;
}
.primary-btn.active,
.el-button.active {
  background-color: #67c23a;
  border-color: #67c23a;
  color: #fff;
}

/* 弹窗圆角 */
.custom-dialog-radius .el-dialog__body {
  border-radius: 16px;
}

/* 移动设备适配 */
@media (max-width: 768px) {
  .el-dialog {
    width: 95vw !important;
    max-width: 95vw !important;
    margin: 2.5vw auto !important;
  }
  
  .interview-setting-container {
    padding: 20px 16px;
    max-width: 100%;
  }
  
  .tab-container {
    flex-direction: column;
    gap: 12px;
    margin-bottom: 16px;
  }
  
  .tab-item {
    padding: 12px 16px;
    font-size: 14px;
  }
  
  :deep(.el-form-item__label) {
    font-size: 13px !important;
    margin-bottom: 6px;
  }
  
  :deep(.el-input__inner) {
    height: 40px;
    font-size: 14px;
  }
  
  :deep(.el-select) {
    width: 100%;
  }
  
  .shortcut-container {
    gap: 10px;
  }
  
  .shortcut-row {
    flex-direction: row;
    align-items: center;
    gap: 8px;
  }
  
  .os-label {
    font-size: 13px;
    width: 60px;
  }
  
  .shortcut-input {
    width: 140px;
    height: 40px;
    font-size: 14px;
    padding: 8px 12px;
  }
  
  .button-group {
    flex-direction: column;
    gap: 12px;
    margin-top: 16px;
  }
  
  .primary-btn {
    width: 100%;
    height: 44px;
    font-size: 16px;
    margin-right: 0;
  }
  
  .el-upload__tip {
    font-size: 11px;
  }
  
  .setting-section {
    margin-bottom: 20px;
  }
  
  .setting-section h3 {
    font-size: 1.2rem;
    margin-bottom: 12px;
  }
  
  .setting-item {
    margin-bottom: 16px;
  }
  
  .setting-item label {
    font-size: 13px;
    margin-bottom: 6px;
  }
  
  .setting-item input,
  .setting-item select {
    height: 40px;
    font-size: 14px;
  }
}

/* 平板设备适配 */
@media (min-width: 769px) and (max-width: 1024px) {
  .el-dialog {
    width: 80vw !important;
    max-width: 80vw !important;
  }
  
  .interview-setting-container {
    padding: 24px 20px;
  }
  
  .tab-container {
    gap: 16px;
    margin-bottom: 20px;
  }
  
  .tab-item {
    padding: 14px 20px;
    font-size: 15px;
  }
  
  :deep(.el-input__inner) {
    height: 42px;
    font-size: 15px;
  }
  
  .shortcut-input {
    height: 42px;
    font-size: 15px;
  }
  
  .primary-btn {
    width: 140px;
    height: 42px;
    font-size: 15px;
  }
  
  .setting-section h3 {
    font-size: 1.3rem;
  }
  
  .setting-item label {
    font-size: 14px;
  }
  
  .setting-item input,
  .setting-item select {
    height: 42px;
    font-size: 15px;
  }
}

/* 小屏手机适配 */
@media (max-width: 480px) {
  .el-dialog {
    width: 98vw !important;
    max-width: 98vw !important;
    margin: 1vw auto !important;
  }
  
  .interview-setting-container {
    padding: 16px 12px;
  }
  
  .tab-container {
    gap: 8px;
    margin-bottom: 12px;
  }
  
  .tab-item {
    padding: 10px 12px;
    font-size: 13px;
  }
  
  :deep(.el-form-item__label) {
    font-size: 12px !important;
    margin-bottom: 4px;
  }
  
  :deep(.el-input__inner) {
    height: 38px;
    font-size: 13px;
  }
  
  .shortcut-container {
    gap: 8px;
  }
  
  .shortcut-row {
    flex-direction: row;
    align-items: center;
    gap: 6px;
  }
  
  .os-label {
    font-size: 12px;
    width: 55px;
  }
  
  .shortcut-input {
    width: 120px;
    height: 38px;
    font-size: 13px;
    padding: 6px 10px;
  }
  
  .button-group {
    margin-top: 12px;
  }
  
  .primary-btn {
    height: 40px;
    font-size: 15px;
  }
  
  .el-upload__tip {
    font-size: 10px;
  }
  
  .setting-section {
    margin-bottom: 16px;
  }
  
  .setting-section h3 {
    font-size: 1.1rem;
    margin-bottom: 10px;
  }
  
  .setting-item {
    margin-bottom: 12px;
  }
  
  .setting-item label {
    font-size: 12px;
    margin-bottom: 4px;
  }
  
  .setting-item input,
  .setting-item select {
    height: 38px;
    font-size: 13px;
  }
}

/* 横屏手机适配 */
@media (max-width: 900px) and (max-height: 600px) {
  .el-dialog {
    width: 90vw !important;
    max-width: 90vw !important;
    max-height: 90vh !important;
    overflow-y: auto;
  }
  
  .interview-setting-container {
    padding: 20px 16px;
  }
  
  .tab-container {
    flex-direction: row;
    gap: 12px;
    margin-bottom: 16px;
  }
  
  .tab-item {
    padding: 12px 16px;
    font-size: 14px;
  }
  
  .button-group {
    flex-direction: row;
    gap: 16px;
  }
  
  .primary-btn {
    width: 120px;
    height: 38px;
    font-size: 14px;
  }
}

/* placeholder文字颜色设置 */
:deep(.el-input__inner::placeholder) {
  color: #b8b2b2 !important;
}

:deep(.el-textarea__inner::placeholder) {
  color: #b8b2b2 !important;
}

:deep(.el-select .el-input__inner::placeholder) {
  color: #b8b2b2 !important;
}
</style>